export default "__VITE_ASSET__196170a1__"